import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { ClientsBulkActionResultModal } from '../ClientsBulkActionResultModal';
import { ClientsBulkDeleteConfirmation } from './ClientsBulkDeleteConfirmation';
export const clientsBulkActionResultModalContent = (result)=>(param)=>{
        let { dismissModal } = param;
        return /*#__PURE__*/ _jsx(ClientsBulkActionResultModal, _object_spread_props(_object_spread({}, result), {
            onClose: ()=>dismissModal(true)
        }));
    };
export const clientsBulkDeleteConfirmationContent = (param)=>{
    let { count, texts } = param;
    return (param)=>{
        let { dismissModal } = param;
        return /*#__PURE__*/ _jsx(ClientsBulkDeleteConfirmation, {
            count: count,
            texts: texts,
            onConfirm: ()=>dismissModal(true),
            onCancel: ()=>dismissModal(false)
        });
    };
};
